import React from 'react';
import PropTypes from 'prop-types';
import segmentPropTypes from './propTypes';
import './styles.scss';
import Picture from '../Picture';
import Map from '../../map/Map/index';
import { noop } from '../propTypes';

function SegmentCard({
    id,
    avatar,
    isActive,
    name,
    litterCount,
    startDate,
    duration,
    distance,
    segmentData,
    onClick,
    zoomLevel,
}) {
    const baseClass = 'segmentCardList mb-3';
    const activeClass = isActive ? `${baseClass} active` : baseClass;
    return (
        <div id={id} onClick={onClick}>
            <div className={activeClass}>
                <div className="segmentCard d-flex flex-wrap align-items-center mb-2">
                    <div className="col">
                        <div className="d-flex align-items-center">
                            <Picture source={avatar} variant={'Small'} />
                            <div className="userName pl-2">
                                {name}
                                <div className="info text-left">
                                    {startDate}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-5">
                        <div className="info">{`${litterCount} Pieces`}</div>
                        <ul className="timingInfo">
                            <li>{duration}</li>
                            <li>{distance}</li>
                        </ul>
                    </div>
                </div>
                <div className="mapWrapper">
                    <Map
                        id="segment-map"
                        drawPolyline={true}
                        center={segmentData[0]}
                        dataPoints={segmentData}
                        zoom={zoomLevel}
                        options={{
                            scrollwheel: false,
                            streetViewControl: false,
                            mapTypeControl: false,
                        }}
                    />
                </div>
            </div>
            <hr />
        </div>
    );
}

SegmentCard.propTypes = {
    ...segmentPropTypes,
    onClick: PropTypes.func,
    zoomLevel: PropTypes.number,
};

SegmentCard.defaultProps = {
    id: null,
    avatar: '',
    name: '',
    litterCount: '',
    startDate: '',
    duration: '',
    distance: '',
    segmentData: [],
    onClick: noop,
    zoomLevel: 13.0,
};

export default SegmentCard;
